import { UILabel, UITableView, UITableViewDatasource, UIView, UITableViewDelegate, UITableViewCell, UIApplication } from "uikit";
import { UITextField, UIControl } from "uikit";
import { UIViewController } from "uikit";
import { IndexPath, NSLocalizeString } from "foundation";
import { DLDB } from "dldb";
import { MUIComboBox, MUIDatePicker } from "muikit";
import { StepView, StepViewProtocol } from "./StepView";
import { BookingProductCell, BookingProductCellDelegate } from "./BookingProductCell";
import { AppDelegate } from "../AppDelegate";

export interface BookingProductProtocolDelegate
{
    onNumProductDidChange  ( vc: BookingProductViewController, numberOfProducts:number ) : void ;
}

export class BookingProductViewController extends UIViewController implements UITableViewDatasource, UITableViewDelegate, BookingProductCellDelegate, StepViewProtocol
{
    delegate : BookingProductProtocolDelegate = null ;

    stepView: StepView;

    private spinLoaderView : UIView;
    private tableView      : UITableView;
    
    errors         : string[]     = [] ;
    
    private hasStarted : boolean  = false ;
    private quantity: number = 0;
    
    viewDidLoad ( )
    {
        this.setErrors( [] ) ;

        this.tableView.dataSource = this;

        // this.fetchProducts();
    }

    public clear() {

      // this.numPeople = -1;      
      // this.set_date( null );
      // this.calendarView.resetSelection();
      // this.paxSegmentedControl.selectSegmentedAtIndex(-1);
      // if (this.paxTextField) this.paxTextField.text = null;

      this.setErrors( [] );

    }

    check ( ) : boolean {
        const errors = [];
        let valid = DLDB.shared.cart().lines.length > 0;
        if (!valid) errors.push("products");
        
        if ( !(UIApplication.shared.delegate as AppDelegate).dryRunCheck ) this.setErrors( errors );
        return valid;
    }

    setErrors ( errors: string[] )
    {
        const errorSpec = this.errorSpec( ) ;

        for ( const err in errorSpec )
            this.clearError( err ) ;

        for ( const err of errors )
            if ( err in errorSpec )
                errorSpec[ err ].hidden = false ;
    }

    clearError ( error: string )
    {
        const errorSpec = this.errorSpec( ) ;

        this.errors = this.errors.filter( e => e !== error ) ;

        if ( errorSpec.hasOwnProperty( error ) )
            errorSpec[ error ].hidden = true ;
    } 

    private errorSpec ( )
    {
        // return { "date": this.errorDateLabel
        //        , "people" : this.errorPeopleLabel
        //        }

        return null;
    }

    public asJSON ( ) : any
    {        
        return [];
    }


    // PRODUCT TABLE VIEW
    numberOfSections ( tableView: UITableView ) { 
        return 1;
    }

    numberOfRowsInSection(tableView: UITableView, section: number): number {        
        return this.products.length;
    }    

    cellForRowAt(tableView: UITableView, indexPath: IndexPath): UITableViewCell
    {
        let cell = tableView.dequeueReusableCellWithIdentifier( "ProductCell" ) as BookingProductCell;
        const product = this.products[ indexPath.row ];
        cell.product = product;
        cell.delegate = this;
        return cell;
    }

    didSelectCellAtIndexPath ( tableView: UITableView, indexPath: IndexPath )
    {
      // this.time_id = this.selected_zone.groups[ indexPath.section ].times[ indexPath.row ].id ;
    
      // if ( this.time_id !== "" )
      //       this.clearError( "time" ) ;

      // this.notify();
    }

    fetchProducts( categoryID?: string ){
        if (categoryID == null ) {
            this.mapItems([]);
            return;
        }

        if (this.spinLoaderView) this.spinLoaderView.hidden = false;

        DLDB.shared.presetProducts( categoryID, (code, res) =>
        {            
            if (this.spinLoaderView) this.spinLoaderView.hidden = true;

            if ( code === 200 ){
                this.mapItems( res.data );
                this.tableView.reloadData();
            }
        } ) ;
    }

    private products: any[] = [];

    private mapItems( items: any[] ){
        this.products = items;
        this.tableView.reloadData();
    }

    private products_set = {};    
    onNumProductDidChange ( cell: BookingProductCell, product: any, quantity:number ) : void {
        this.quantity += quantity;

        let item = this.products_set[ product["ID"] ] ?? {"Name": product["Name"], "Qty": 0 };
        if ( quantity <= 0 ) {
            delete this.products_set[ product["ID"] ];
        }
        else {
            item["Qty"] = quantity;
            this.products_set[ product["ID"] ] = item;
        }

        DLDB.shared.cart().updateProductQuantity( product["ID"], product["Name"], product["Price"], quantity, product["RecommendedProducts"] );

        this.delegate?.onNumProductDidChange( this, this.quantity );
    }
}
